import { LoadingButton } from '@mui/lab';
import { Button, Grid, Typography } from '@mui/material';
import { FC, useState } from 'react';

import { PaperModal } from '../';

import { IConfirmActionModalProperties } from './types';

export const ConfirmActionModal: FC<IConfirmActionModalProperties> = ({
  question,
  description,
  confirm,
  cancel,
  confirmColor = 'primary',
  open,
  onClose,
  onSubmit,
}) => {
  const [isLoading, setLoading] = useState(false);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      setLoading(true);
      await onSubmit?.(event);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaperModal open={open} onClose={onClose}>
      <Grid container spacing={2} maxWidth={520}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              mb: description ? 1 : 0,
              color: confirmColor === 'error' ? 'error.main' : undefined,
              fontWeight: 700,
            }}
          >
            {question}
          </Typography>
          {description && (
            <Typography
              variant="body1"
              sx={{
                color:
                  confirmColor === 'error' ? 'error.main' : 'text.secondary',
                fontWeight: confirmColor === 'error' ? 700 : 400,
                whiteSpace: 'pre-line',
              }}
            >
              {description}
            </Typography>
          )}
        </Grid>
        <Grid item xs={6}>
          <LoadingButton
            loading={isLoading}
            onClick={handleClick}
            variant="contained"
            color={confirmColor}
            fullWidth
            aria-label="confirm"
            autoFocus
          >
            {confirm}
          </LoadingButton>
        </Grid>
        <Grid item xs={6}>
          <Button
            disabled={isLoading}
            variant="outlined"
            fullWidth
            onClick={onClose}
            aria-label="cancel"
          >
            {cancel}
          </Button>
        </Grid>
      </Grid>
    </PaperModal>
  );
};
